import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import { createPinia } from 'pinia'
import '@/assets/font/iconfont.css'
import '@/assets/font/iconfont.js'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import "./registerServiceWorker";
import 'katex/dist/katex.min.css';
import VueLatex from 'vatex';

document.addEventListener('contextmenu', e => e.preventDefault());

const app = createApp(App)
app.use(VueLatex)
app.use(createPinia()).use(router).use(ElementPlus).mount('#app')
